import React from 'react';
import Header from '../../Layout/Header';
import Sidebar from '../../Layout/Sidebar';
import Breadcrumbs from '../../components/Breadcrumb';
import MarkTopicAsReadButton from '../../components/MarkTopicAsReadButton';
import { useChecklist } from '../../context/ChecklistContext';
import { FooterMobile } from '../../Layout/FooterMobile';
import { useOverviewContext } from '../../context/OverviewContext';
import LCLife from '../../assets/images/siteImg/checklistImg/Image_LearningCoachLifeOverview.png';
import statImage1 from '../../assets/images/siteImg/StatImage_4-6-1.png';
import statImage2 from '../../assets/images/siteImg/StatImage_1-3.png';

const LearningCoachOverviewDetails: React.FC = () => {
interface LessonDetails {
    schoolName: string;
    gradeRange?: string;
    img: string;
    title: string;
    desc: string;
}
const { students } = useOverviewContext();
const breadcrumbItems = [
    { label: "Home", path: "/" },
    { label: "School Prep Checklist", path: "/school-prep-checklist" },
    { label: "Learning Coach Life", path: "/k12-checklist-category/learning-coach-life" },
    { label: "What is a Learning Coach (LC)?" }, 
];
// Get checklist data & currentChecklistId from ChecklistContext
const { checklistData } = useChecklist();
const getChecklistName = checklistData.find(item => item.checklistName === "WHAT_IS_A_LEARNING_COACH");
const currentChecklistId = getChecklistName ? getChecklistName.checklistId.toString() : null;

// GRADE LOGIC
const getLessonDetails = (grade: number | string) => {
    const numericGrade = !isNaN(Number(grade)) ? Number(grade) : grade;
    console.log(typeof grade, numericGrade);

    if (numericGrade === 'K' || (typeof numericGrade === 'number' && numericGrade >= 0 && numericGrade <= 5)) {
        return {
            schoolName: "Elementary School",
            gradeRange : "K-5",
            img: statImage1,
            title: "Average Elementary School Time Commitment",
            desc: "For grades K-5, Learning Coaches play a more hands-on role, guiding students through lessons, keeping them engaged, and building the foundation for future success."
        };
    } else if (typeof numericGrade === 'number' && numericGrade >= 6 && numericGrade <= 8) {
        return {
            schoolName: "Middle School",
            gradeRange : "6-8",
            img: statImage2,
            title: "Average Middle School Time Commitment",
            desc: "Middle school students begin to grow as independent learners, and the role of Learning Coach often shifts to include modeling important life skills like organization and time management."
        };
    } else if (typeof numericGrade === 'number' && numericGrade >= 9 && numericGrade <= 12) {
        return {
            schoolName: "High School",
            gradeRange : "9-12",
            img: statImage2,
            title: "Average High School Time Commitment",
            desc: "High school is a busy time of exploring extracurricular activities, electives, and options for college and career. Help keep students on track and cheer them on!"
        };
    }
    return { schoolName: "", title: "", desc: "", img:"" };
};
// Get unique each school cards
const uniqueSchoolCards: LessonDetails[] = students.reduce((acc: LessonDetails[], student) => {
    const studentGradeVal = student.grade.gradeId;
    const lessonDetails = getLessonDetails(studentGradeVal);

    if (lessonDetails && lessonDetails.schoolName && !acc.some(item => item.schoolName === lessonDetails.schoolName)) {
        acc.push(lessonDetails);
    }
    return acc;
}, []);

return (
    <div className="home-layout">
        <div className="sidebar-wrapper">
        <Sidebar />
        </div>
        <div className="body-wrapper-content">
            <div className="row">
                <div className="col-12">
                    <Header />
                    <div className="main-content pt-4 pt-md-0">
                        <div className="row">
                            <div className="col-12">
                                <Breadcrumbs items={breadcrumbItems} />
                            </div>
                        </div>
                        
                        <div className="wp-block-columns is-layout-flex">
                            <div className="wp-block-column is-layout-flow" style={{ flexBasis: "66.66%" }}>

                           

                                <div className="wp-block-k12-section container-fluid  bg-transparent">
                                    <h1 className='wp-block-heading'>What is a Learning Coach (LC)?</h1>
                                    <h4 className='wp-block-heading'>A Learning Coach is a parent, relative, sibling, or legal guardian who supports a student’s online education journey at home.</h4>
                                </div>
                                
                                <div className="wp-block-k12-section container-fluid  bg-color-blue-t1-checklist p-2rem">
                                    <div className="wp-block-k12-section container-fluid bg-color-white ps-4 p-2rem overflow-hidden">
                                        <div className="row">
                                            <div className="col-12 g-0">
                                                <div className="wp-block-columns is-layout-flex wp-container-core-columns-is-layout-1 wp-block-columns-is-layout-flex">
                                                    <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow">
                                                        <h2 className="wp-block-heading">Learning Coach vs. Teacher</h2>
                                                        <p><p>As a Learning Coach, you'll help your child with all life's little details, just as you would while caring for them while they’re not in school. But you'll also partner with state-certified teachers to create an inspiring, customized learning experience for your student.</p>
                                                        </p>
                                                    </div>
                                                    <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow">
                                                        <figure className="wp-block-image alignright size-medium">
                                                            <img src={LCLife} alt="Learning Coach Life" sizes="(max-width: 264px) 100vw, 264px" />
                                                        </figure>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                
                                
                                    <h3 className='wp-block-heading'>Here’s a quick explanation of the roles teachers and Learning Coaches play:</h3>
                                    <div className="row">
                                        <div className="col-md-6">
                                        <p><strong>Teachers:</strong></p>
                                        <ul>
                                            <li>Set lesson plans</li>
                                            <li>Host live, direct instruction sessions</li>
                                            <li>Grade and assess student performance</li>
                                            <li>Provide differentiated instruction as needed</li>
                                            <li>Host office hours or check-in times</li>
                                        </ul>
                                        </div>
                                        <div className="col-md-6">
                                        <p><strong>Learning Coaches:</strong></p>
                                        <ul>
                                            <li>Facilitate/monitor lessons</li>
                                            <li>Make sure students attend virtual classes</li>
                                            <li>Help students track and submit work</li>
                                            <li>Assist students with questions about lessons</li>
                                            <li>Maintain communication with teachers</li>
                                        </ul>
                                        </div>
                                    </div>
                                </div>
                                
                                {/* Learning Coach Life */}
                                <h1 className='wp-block-heading'><strong>Learning Coach Life</strong></h1>
                                <h4 className='wp-block-heading'>A Learning Coach’s daily time commitment and engagement will vary depending on the student.</h4>
                    
                    
                                {/* Time Commitment Cards  Call Grade Logic */}
                                <div className="wp-block-group row is-layout-constrained wp-block-group-is-layout-constrained">
                                    {uniqueSchoolCards.map((item, index) => {
                                    return (
                                        <div key={index} className="wp-block-k12-school-content-wrapper alignleft col-12 col-md-6 me-0 mb-3 mb-md-0">
                                        <div className="wp-block-k12-section container-fluid  bg-color-light-gray-3 p-2rem">
                                            <div className="row">
                                                <div className="col-12 g-0">
                                                    <div className="wp-block-columns is-layout-flex wp-container-core-columns-is-layout-3 wp-block-columns-is-layout-flex">
                                                    <div className="wp-block-column is-vertically-aligned-center is-layout-flow wp-block-column-is-layout-flow"
                                                        style={{ flexBasis: '33.33%' }}>
                                                        <figure className="wp-block-image aligncenter size-full is-resized">
                                                            <img src={item.img} alt={item.title} className="w-24 h-24 mr-4" style={{ objectFit: 'cover', width: '112px', height: '112px' }} />
                                                        </figure>
                                                    
                                                    </div>
                                                        
                                                    <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow" style={{flexBasis:'66.66%' }}>
                                                        <p><strong>{item.title}</strong></p>
                                                        <p className="m-0">{item.desc}</p>
                                                    </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        </div>
                                    );
                                })}
                                </div>
                                
                            </div>
                            <div className="wp-block-column is-layout-flow" style={{ flexBasis: "33.33%" }}></div>
                        </div>
                        
                        {/* <MarkTopicAsReadButton checklistId="102" /> */}
                        {currentChecklistId && <MarkTopicAsReadButton checklistId={currentChecklistId} />}

                    </div>
                    
                </div>

            </div>
        </div>
        <FooterMobile />
    </div>
    
);
};
export default LearningCoachOverviewDetails;